export const ROOT = 'typeOperation';

export const FETCH_TYPE_OPERATION_REQUEST = `${ROOT}/FETCH_TYPE_OPERATION_REQUEST`;
export const FETCH_TYPE_OPERATION_FAILURE = `${ROOT}/FETCH_TYPE_OPERATION_FAILURE`;
export const FETCH_TYPE_OPERATION_SUCCESS = `${ROOT}/FETCH_TYPE_OPERATION_SUCCESS`;

export const CLEAR_TYPE_OPERATION_DATA = `${ROOT}/CLEAR_TYPE_OPERATION_DATA`;
